import { useI18n } from '@change-corgi/core/react/i18n';

type Result = ModelHookResult<{
	placeholder: string;
	resetLabel: string;
}>;

export function useTranslations(): Result {
	const { translate } = useI18n();

	return {
		data: {
			placeholder: translate('corgi.search.filters.location.input_placeholder'),
			resetLabel: translate('corgi.search.search_box.reset'),
		},
	};
}
